<template>
  <div class="product-list">
    <div class="product-finder--filter" style="display: flex; gap: 10px; justify-content: flex-start;">
      <Select v-model="filter.product_type" :placeholder="$t('product.info.product_type')" clearable>
        <Option value="product">Product</Option>
        <Option value="service">Service</Option>
      </Select>
      <Input v-model="filter.product_name" placeholder="Enter product name to search.."></Input>
      <Button type="primary" @click="findProducts">Go</Button>
    </div>
    <div class="product-finder--list" style="margin-top: 30px">
      <vxe-table :loading="loading" :data="tableData" size="mini">
        <vxe-column type="seq" width="60" align="center"></vxe-column>
        <vxe-column field="product_name" title="Name"></vxe-column>
        <vxe-column field="product_type" title="Type"></vxe-column>
        <vxe-column field="data.category" title="Category"></vxe-column>
        <vxe-column field="erp_id" title="Product ID"></vxe-column>
        <vxe-column field="lifecycle_status" title="Lifecycle St." align="center">
          <template #default="{ row }"><span class="ivu-badge info"><a href="#"></a><sup class="ivu-badge-count" :style="`background: ${row.lifecycle_status === 'active' ? '#19be6b' : '#3d4014'}`">{{ row.lifecycle_status }}</sup></span></template>
        </vxe-column>
        <vxe-column field="created_at" title="Created At" align="center"></vxe-column>
        <vxe-column title="Actions">
          <template #default="{ row }">
            <Button type="text" @click="handleProductSelected(row)">{{ $t('select') }}</Button>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
  </div>
</template>

<script>
import { loadProducts } from '@/api/product'
export default {
  name: 'ProductListWithFilter',
  data() {
    return {
      product: null,
      filter: { product_type: null, product_name: '', lifecycle_status: 'active' },
      tableData: [],
      pager: {},
      loading: false
    }
  },
  mounted () {
    this.findProducts()
  },
  methods: {
    findProducts () {
      // Build search query with blank values removed
      let search = Object.entries(this.filter).filter(([_, v]) => v).map((e) => {
        return e.join(':')
      }).join(';')

      this.loading = true
      loadProducts({ search: search, searchJoin: 'and', orderBy: 'id', sortedBy: 'desc' }).then(resp => {
        this.tableData = resp.data.data
        this.pager = resp.data.meta
      }).finally(() => {
        this.loading = false
      })
    },
    handleProductSelected (row) {
      this.$emit('on-selected', row)
    }
  }
}
</script>
